<h5>Tarefas para Atualização de Máquina do Tempo</h5>

<div class="container">
  <div ngbAccordion>
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button class="title" ngbAccordionButton>Alterar Data</button>
      </h2>

      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template ngbPanelContent>
            <div class="row">

              <div class="col-md-5">
                <label>Data Atual do Sistema:</label>
                <bn-datepicker
                    disabled
                    name="dataSistema"
                    [(ngModel)]="dataSistema">
                </bn-datepicker>
              </div>

              <div class="col-md-5">
                <label>Nova Data:</label>
                <bn-datepicker
                    name="data"
                    idInput="data"
                    ngDefaultControl
                    [(ngModel)]="data">
                </bn-datepicker>
              </div>

            </div>

            <div class="row">

              <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin" (click)="alterarData()">Alterar</button>
              </div>

              <div class="submit col-auto">
                <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
              </div>

            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

